/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getCart(body: GetCartCommandRequest | undefined): Promise<GetCartCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    removeFromCart(body: RemoveFromCartCommandRequest | undefined): Promise<RemoveFromCartCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upsertToCart(body: UpsertToCartCommandRequest | undefined): Promise<UpsertToCartCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    closeActiveCart(body: CloseActiveCartCommandRequest | undefined): Promise<CloseActiveCartCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    emptyCart(body: EmptyCartCommandRequest | undefined): Promise<EmptyCartCommandResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse>;
    /**
     * @return Success
     */
    refreshUMAToken(): Promise<LoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolForLoggedInUser(body: GetFilteredTrackedBolForLoggedInUserQueryRequest | undefined): Promise<GetFilteredTrackedBolForLoggedInUserQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolForAdmin(body: GetFilteredTrackedBolForAdminQueryRequest | undefined): Promise<GetFilteredTrackedBolForAdminQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getTrackedBolDetailsById(body: GetTrackedBolDetailsByIdCommandRequest | undefined): Promise<GetTrackedBolDetailsByIdCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBol(body: UpdateTrackedBolCommandRequest | undefined): Promise<UpdateTrackedBolCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBolStatus(body: UpdateTrackedBolStatusCommandRequest | undefined): Promise<UpdateTrackedBolStatusCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addTrackedBol(body: AddTrackedBolCommandRequest | undefined): Promise<AddTrackedBolCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getTrackedBolDetailsByBolReference(body: GetTrackedBolDetailsByBolReferenceCommandRequest | undefined): Promise<GetTrackedBolDetailsByBolReferenceCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolDescriptionForLoggedUser(body: GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest | undefined): Promise<GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBolSupplementaryInfo(body: UpdateTrackedBolSupplementaryInfoRequest | undefined): Promise<UpdateTrackedBolSupplementaryInfoResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCustomerTrackedBolReport(body: GetCustomerTrackedBolReportRequest | undefined): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getCustomerTrackedBolReport2(body: GetCustomerTrackedBolReportRequest | undefined): Promise<FileResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolFileTypeForLoggedInUser(body: GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest | undefined): Promise<GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse>;
    /**
     * @return Success
     */
    getTrackedBolFileById(id: string | null): Promise<GetTrackedBolFileByIdQueryResponse>;
    /**
     * @return Success
     */
    getTrackedBolFileById2(id: string | null): Promise<GetTrackedBolFileByIdQueryResponse>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCart(body: GetCartCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetCartCommandResponse> {
        let url_ = this.baseUrl + "/api/Cart/GetCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCart(_response);
        });
    }

    protected processGetCart(response: AxiosResponse): Promise<GetCartCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCartCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCartCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeFromCart(body: RemoveFromCartCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<RemoveFromCartCommandResponse> {
        let url_ = this.baseUrl + "/api/Cart/RemoveFromCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromCart(_response);
        });
    }

    protected processRemoveFromCart(response: AxiosResponse): Promise<RemoveFromCartCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveFromCartCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveFromCartCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertToCart(body: UpsertToCartCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpsertToCartCommandResponse> {
        let url_ = this.baseUrl + "/api/Cart/UpsertToCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertToCart(_response);
        });
    }

    protected processUpsertToCart(response: AxiosResponse): Promise<UpsertToCartCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpsertToCartCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpsertToCartCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeActiveCart(body: CloseActiveCartCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CloseActiveCartCommandResponse> {
        let url_ = this.baseUrl + "/api/Cart/CloseActiveCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseActiveCart(_response);
        });
    }

    protected processCloseActiveCart(response: AxiosResponse): Promise<CloseActiveCartCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloseActiveCartCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloseActiveCartCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emptyCart(body: EmptyCartCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<EmptyCartCommandResponse> {
        let url_ = this.baseUrl + "/api/Cart/EmptyCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmptyCart(_response);
        });
    }

    protected processEmptyCart(response: AxiosResponse): Promise<EmptyCartCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyCartCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyCartCommandResponse>(<any>null);
    }

    /**
     * @return Success
     */
    logout(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(<any>null);
    }

    /**
     * @return Success
     */
    refreshUMAToken(  cancelToken?: CancelToken | undefined): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/RefreshUMAToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshUMAToken(_response);
        });
    }

    protected processRefreshUMAToken(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolForLoggedInUser(body: GetFilteredTrackedBolForLoggedInUserQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetFilteredTrackedBolForLoggedInUserQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetFilteredTrackedBolForLoggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredTrackedBolForLoggedInUser(_response);
        });
    }

    protected processGetFilteredTrackedBolForLoggedInUser(response: AxiosResponse): Promise<GetFilteredTrackedBolForLoggedInUserQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredTrackedBolForLoggedInUserQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredTrackedBolForLoggedInUserQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolForAdmin(body: GetFilteredTrackedBolForAdminQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetFilteredTrackedBolForAdminQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetFilteredTrackedBolForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredTrackedBolForAdmin(_response);
        });
    }

    protected processGetFilteredTrackedBolForAdmin(response: AxiosResponse): Promise<GetFilteredTrackedBolForAdminQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredTrackedBolForAdminQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredTrackedBolForAdminQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTrackedBolDetailsById(body: GetTrackedBolDetailsByIdCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetTrackedBolDetailsByIdCommandResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetTrackedBolDetailsById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedBolDetailsById(_response);
        });
    }

    protected processGetTrackedBolDetailsById(response: AxiosResponse): Promise<GetTrackedBolDetailsByIdCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTrackedBolDetailsByIdCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTrackedBolDetailsByIdCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBol(body: UpdateTrackedBolCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateTrackedBolCommandResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/UpdateTrackedBol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrackedBol(_response);
        });
    }

    protected processUpdateTrackedBol(response: AxiosResponse): Promise<UpdateTrackedBolCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTrackedBolCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTrackedBolCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBolStatus(body: UpdateTrackedBolStatusCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateTrackedBolStatusCommandResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/UpdateTrackedBolStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrackedBolStatus(_response);
        });
    }

    protected processUpdateTrackedBolStatus(response: AxiosResponse): Promise<UpdateTrackedBolStatusCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTrackedBolStatusCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTrackedBolStatusCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addTrackedBol(body: AddTrackedBolCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<AddTrackedBolCommandResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/AddTrackedBol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTrackedBol(_response);
        });
    }

    protected processAddTrackedBol(response: AxiosResponse): Promise<AddTrackedBolCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddTrackedBolCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddTrackedBolCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTrackedBolDetailsByBolReference(body: GetTrackedBolDetailsByBolReferenceCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetTrackedBolDetailsByBolReferenceCommandResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetTrackedBolDetailsByBolReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedBolDetailsByBolReference(_response);
        });
    }

    protected processGetTrackedBolDetailsByBolReference(response: AxiosResponse): Promise<GetTrackedBolDetailsByBolReferenceCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTrackedBolDetailsByBolReferenceCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTrackedBolDetailsByBolReferenceCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolDescriptionForLoggedUser(body: GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetFilteredTrackedBolDescriptionForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredTrackedBolDescriptionForLoggedUser(_response);
        });
    }

    protected processGetFilteredTrackedBolDescriptionForLoggedUser(response: AxiosResponse): Promise<GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTrackedBolSupplementaryInfo(body: UpdateTrackedBolSupplementaryInfoRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateTrackedBolSupplementaryInfoResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/UpdateTrackedBolSupplementaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTrackedBolSupplementaryInfo(_response);
        });
    }

    protected processUpdateTrackedBolSupplementaryInfo(response: AxiosResponse): Promise<UpdateTrackedBolSupplementaryInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateTrackedBolSupplementaryInfoResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateTrackedBolSupplementaryInfoResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCustomerTrackedBolReport(body: GetCustomerTrackedBolReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetCustomerTrackedBolReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTrackedBolReport(_response);
        });
    }

    protected processGetCustomerTrackedBolReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCustomerTrackedBolReport2(body: GetCustomerTrackedBolReportRequest | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrackedBol/GetCustomerTrackedBolReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "HEAD",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTrackedBolReport2(_response);
        });
    }

    protected processGetCustomerTrackedBolReport2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredTrackedBolFileTypeForLoggedInUser(body: GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBolFile/GetFilteredTrackedBolFileTypeForLoggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredTrackedBolFileTypeForLoggedInUser(_response);
        });
    }

    protected processGetFilteredTrackedBolFileTypeForLoggedInUser(response: AxiosResponse): Promise<GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getTrackedBolFileById(id: string | null , cancelToken?: CancelToken | undefined): Promise<GetTrackedBolFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBolFile/GetTrackedBolFileById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedBolFileById(_response);
        });
    }

    protected processGetTrackedBolFileById(response: AxiosResponse): Promise<GetTrackedBolFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTrackedBolFileByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTrackedBolFileByIdQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getTrackedBolFileById2(id: string | null , cancelToken?: CancelToken | undefined): Promise<GetTrackedBolFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/TrackedBolFile/GetTrackedBolFileById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedBolFileById2(_response);
        });
    }

    protected processGetTrackedBolFileById2(response: AxiosResponse): Promise<GetTrackedBolFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTrackedBolFileByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTrackedBolFileByIdQueryResponse>(<any>null);
    }
}

export class GetCartCommandRequest implements IGetCartCommandRequest {

    constructor(data?: IGetCartCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCartCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCartCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetCartCommandRequest {
        const json = this.toJSON();
        let result = new GetCartCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetCartCommandRequest {
}

export enum CartStatus {
    Finialized = "Finialized",
    Active = "Active",
}

export class CartItem implements ICartItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    itemReference?: string | undefined;
    pickupDate?: string;
    updateDate?: string | undefined;
    name?: string | undefined;
    cost?: number;
    additionalInfo?: string | undefined;
    cartId?: string;
    cart?: Cart;

    constructor(data?: ICartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.itemReference = _data["itemReference"];
            this.pickupDate = _data["pickupDate"];
            this.updateDate = _data["updateDate"];
            this.name = _data["name"];
            this.cost = _data["cost"];
            this.additionalInfo = _data["additionalInfo"];
            this.cartId = _data["cartId"];
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CartItem {
        data = typeof data === 'object' ? data : {};
        let result = new CartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["itemReference"] = this.itemReference;
        data["pickupDate"] = this.pickupDate;
        data["updateDate"] = this.updateDate;
        data["name"] = this.name;
        data["cost"] = this.cost;
        data["additionalInfo"] = this.additionalInfo;
        data["cartId"] = this.cartId;
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CartItem {
        const json = this.toJSON();
        let result = new CartItem();
        result.init(json);
        return result;
    }
}

export interface ICartItem {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    itemReference?: string | undefined;
    pickupDate?: string;
    updateDate?: string | undefined;
    name?: string | undefined;
    cost?: number;
    additionalInfo?: string | undefined;
    cartId?: string;
    cart?: ICart;
}

export class Cart implements ICart {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userId?: string;
    total?: number;
    status?: CartStatus;
    cartItems?: CartItem[] | undefined;

    constructor(data?: ICart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.cartItems) {
                this.cartItems = [];
                for (let i = 0; i < data.cartItems.length; i++) {
                    let item = data.cartItems[i];
                    this.cartItems[i] = item && !(<any>item).toJSON ? new CartItem(item) : <CartItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.userId = _data["userId"];
            this.total = _data["total"];
            this.status = _data["status"];
            if (Array.isArray(_data["cartItems"])) {
                this.cartItems = [] as any;
                for (let item of _data["cartItems"])
                    this.cartItems!.push(CartItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Cart {
        data = typeof data === 'object' ? data : {};
        let result = new Cart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["userId"] = this.userId;
        data["total"] = this.total;
        data["status"] = this.status;
        if (Array.isArray(this.cartItems)) {
            data["cartItems"] = [];
            for (let item of this.cartItems)
                data["cartItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Cart {
        const json = this.toJSON();
        let result = new Cart();
        result.init(json);
        return result;
    }
}

export interface ICart {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userId?: string;
    total?: number;
    status?: CartStatus;
    cartItems?: ICartItem[] | undefined;
}

export class GetCartCommandResponse implements IGetCartCommandResponse {
    cart?: Cart;

    constructor(data?: IGetCartCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCartCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCartCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCartCommandResponse {
        const json = this.toJSON();
        let result = new GetCartCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCartCommandResponse {
    cart?: ICart;
}

export class RemoveFromCartCommandRequest implements IRemoveFromCartCommandRequest {
    itemReference?: string | undefined;

    constructor(data?: IRemoveFromCartCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemReference = _data["itemReference"];
        }
    }

    static fromJS(data: any): RemoveFromCartCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFromCartCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemReference"] = this.itemReference;
        return data; 
    }

    clone(): RemoveFromCartCommandRequest {
        const json = this.toJSON();
        let result = new RemoveFromCartCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRemoveFromCartCommandRequest {
    itemReference?: string | undefined;
}

export class RemoveFromCartCommandResponse implements IRemoveFromCartCommandResponse {
    cart?: Cart;

    constructor(data?: IRemoveFromCartCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveFromCartCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFromCartCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RemoveFromCartCommandResponse {
        const json = this.toJSON();
        let result = new RemoveFromCartCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoveFromCartCommandResponse {
    cart?: ICart;
}

export class UpsertToCartCommandRequest implements IUpsertToCartCommandRequest {
    itemReference?: string | undefined;
    pickupDate?: string | undefined;
    cost?: number | undefined;
    additionalInfo?: string | undefined;

    constructor(data?: IUpsertToCartCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemReference = _data["itemReference"];
            this.pickupDate = _data["pickupDate"];
            this.cost = _data["cost"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): UpsertToCartCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertToCartCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemReference"] = this.itemReference;
        data["pickupDate"] = this.pickupDate;
        data["cost"] = this.cost;
        data["additionalInfo"] = this.additionalInfo;
        return data; 
    }

    clone(): UpsertToCartCommandRequest {
        const json = this.toJSON();
        let result = new UpsertToCartCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpsertToCartCommandRequest {
    itemReference?: string | undefined;
    pickupDate?: string | undefined;
    cost?: number | undefined;
    additionalInfo?: string | undefined;
}

export class UpsertToCartCommandResponse implements IUpsertToCartCommandResponse {
    cart?: Cart;

    constructor(data?: IUpsertToCartCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertToCartCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertToCartCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpsertToCartCommandResponse {
        const json = this.toJSON();
        let result = new UpsertToCartCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpsertToCartCommandResponse {
    cart?: ICart;
}

export class CloseActiveCartCommandRequest implements ICloseActiveCartCommandRequest {

    constructor(data?: ICloseActiveCartCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CloseActiveCartCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloseActiveCartCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): CloseActiveCartCommandRequest {
        const json = this.toJSON();
        let result = new CloseActiveCartCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICloseActiveCartCommandRequest {
}

export class CloseActiveCartCommandResponse implements ICloseActiveCartCommandResponse {

    constructor(data?: ICloseActiveCartCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CloseActiveCartCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CloseActiveCartCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): CloseActiveCartCommandResponse {
        const json = this.toJSON();
        let result = new CloseActiveCartCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICloseActiveCartCommandResponse {
}

export class EmptyCartCommandRequest implements IEmptyCartCommandRequest {

    constructor(data?: IEmptyCartCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EmptyCartCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCartCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): EmptyCartCommandRequest {
        const json = this.toJSON();
        let result = new EmptyCartCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IEmptyCartCommandRequest {
}

export class EmptyCartCommandResponse implements IEmptyCartCommandResponse {
    cart?: Cart;

    constructor(data?: IEmptyCartCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cart = data.cart && !(<any>data.cart).toJSON ? new Cart(data.cart) : <Cart>this.cart; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? Cart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmptyCartCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyCartCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EmptyCartCommandResponse {
        const json = this.toJSON();
        let result = new EmptyCartCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEmptyCartCommandResponse {
    cart?: ICart;
}

export class LoginCommandRequest implements ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
    reCaptchaToken?: string | undefined;

    constructor(data?: ILoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.reCaptchaToken = _data["reCaptchaToken"];
        }
    }

    static fromJS(data: any): LoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["reCaptchaToken"] = this.reCaptchaToken;
        return data; 
    }

    clone(): LoginCommandRequest {
        const json = this.toJSON();
        let result = new LoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
    reCaptchaToken?: string | undefined;
}

export class SlimUser implements ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    phoneNumber?: string | undefined;
    sessionId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    umaid?: string | undefined;
    customerCode?: string | undefined;
    fullName?: string | undefined;
    groups?: string[] | undefined;

    constructor(data?: ISlimUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.phoneNumber = _data["phoneNumber"];
            this.sessionId = _data["sessionId"];
            this.username = _data["username"];
            this.email = _data["email"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.umaid = _data["umaid"];
            this.customerCode = _data["customerCode"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): SlimUser {
        data = typeof data === 'object' ? data : {};
        let result = new SlimUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["phoneNumber"] = this.phoneNumber;
        data["sessionId"] = this.sessionId;
        data["username"] = this.username;
        data["email"] = this.email;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["umaid"] = this.umaid;
        data["customerCode"] = this.customerCode;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data; 
    }

    clone(): SlimUser {
        const json = this.toJSON();
        let result = new SlimUser();
        result.init(json);
        return result;
    }
}

export interface ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    phoneNumber?: string | undefined;
    sessionId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    umaid?: string | undefined;
    customerCode?: string | undefined;
    fullName?: string | undefined;
    groups?: string[] | undefined;
}

export class LoginCommandResponse implements ILoginCommandResponse {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    user?: SlimUser;

    constructor(data?: ILoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fullname = _data["fullname"];
            this.loggedIn = _data["loggedIn"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.accessToken = _data["accessToken"];
            this.user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullname"] = this.fullname;
        data["loggedIn"] = this.loggedIn;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LoginCommandResponse {
        const json = this.toJSON();
        let result = new LoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandResponse {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    user?: ISlimUser;
}

export enum FilterType {
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
    LessThan = "LessThan",
    LessThanOrEqualTo = "LessThanOrEqualTo",
    Equal = "Equal",
    Group = "Group",
}

export enum JoinType {
    And = "and",
    Or = "or",
}

export class Filter implements IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: Filter[] | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groupFilters) {
                this.groupFilters = [];
                for (let i = 0; i < data.groupFilters.length; i++) {
                    let item = data.groupFilters[i];
                    this.groupFilters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterType = _data["filterType"];
            this.value = _data["value"];
            this.joinType = _data["joinType"];
            if (Array.isArray(_data["groupFilters"])) {
                this.groupFilters = [] as any;
                for (let item of _data["groupFilters"])
                    this.groupFilters!.push(Filter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterType"] = this.filterType;
        data["value"] = this.value;
        data["joinType"] = this.joinType;
        if (Array.isArray(this.groupFilters)) {
            data["groupFilters"] = [];
            for (let item of this.groupFilters)
                data["groupFilters"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: IFilter[] | undefined;
}

export class OrderBy implements IOrderBy {
    field?: string | undefined;
    ascending?: boolean;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["ascending"] = this.ascending;
        return data; 
    }

    clone(): OrderBy {
        const json = this.toJSON();
        let result = new OrderBy();
        result.init(json);
        return result;
    }
}

export interface IOrderBy {
    field?: string | undefined;
    ascending?: boolean;
}

export class GetFilteredTrackedBolForLoggedInUserQueryRequest implements IGetFilteredTrackedBolForLoggedInUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredTrackedBolForLoggedInUserQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolForLoggedInUserQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolForLoggedInUserQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredTrackedBolForLoggedInUserQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolForLoggedInUserQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolForLoggedInUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class Department implements IDepartment {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["name"] = this.name;
        return data; 
    }

    clone(): Department {
        const json = this.toJSON();
        let result = new Department();
        result.init(json);
        return result;
    }
}

export interface IDepartment {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
}

export class Company implements ICompany {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["name"] = this.name;
        return data; 
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
}

export class Employee implements IEmployee {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    departmentId?: string | undefined;
    department?: Department;
    companyId?: string | undefined;
    company?: Company;
    readonly name?: string | undefined;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.department = data.department && !(<any>data.department).toJSON ? new Department(data.department) : <Department>this.department; 
            this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data; 
    }

    clone(): Employee {
        const json = this.toJSON();
        let result = new Employee();
        result.init(json);
        return result;
    }
}

export interface IEmployee {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    departmentId?: string | undefined;
    department?: IDepartment;
    companyId?: string | undefined;
    company?: ICompany;
    name?: string | undefined;
}

export enum TrackedBolServiceCategory {
    Agent = "Agent",
    FullService = "FullService",
}

export enum TrackedBolStatus {
    Submitted = "Submitted",
    UserInterventionRequired = "UserInterventionRequired",
    Accepted = "Accepted",
    Declared = "Declared",
    ReadyForPaymentPreInspection = "ReadyForPaymentPreInspection",
    PaidPreInspection = "PaidPreInspection",
    Inspected = "Inspected",
    ReadyForPaymentPostInspection = "ReadyForPaymentPostInspection",
    PaidPostInspection = "PaidPostInspection",
    ReadyForPickUp = "ReadyForPickUp",
    Exited = "Exited",
}

export class TrackedBolHistory implements ITrackedBolHistory {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    trackedBolId?: string;
    trackedBol?: TrackedBol;
    status?: TrackedBolStatus;
    serviceCategory?: TrackedBolServiceCategory;
    comment?: string | undefined;
    declarationNumber?: string | undefined;
    estimatedValue?: number | undefined;
    receiptNumber?: string | undefined;
    orderReferenceNumber?: string | undefined;
    paymentAmount?: number | undefined;
    gatePassNumber?: string | undefined;
    pickUpDate?: string | undefined;
    notificationGenerated?: boolean | undefined;
    gatePassResponse?: string | undefined;
    customsRelease?: string | undefined;
    readonly currentStatusForCustomer?: string | undefined;

    constructor(data?: ITrackedBolHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.trackedBolId = _data["trackedBolId"];
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
            this.status = _data["status"];
            this.serviceCategory = _data["serviceCategory"];
            this.comment = _data["comment"];
            this.declarationNumber = _data["declarationNumber"];
            this.estimatedValue = _data["estimatedValue"];
            this.receiptNumber = _data["receiptNumber"];
            this.orderReferenceNumber = _data["orderReferenceNumber"];
            this.paymentAmount = _data["paymentAmount"];
            this.gatePassNumber = _data["gatePassNumber"];
            this.pickUpDate = _data["pickUpDate"];
            this.notificationGenerated = _data["notificationGenerated"];
            this.gatePassResponse = _data["gatePassResponse"];
            this.customsRelease = _data["customsRelease"];
            (<any>this).currentStatusForCustomer = _data["currentStatusForCustomer"];
        }
    }

    static fromJS(data: any): TrackedBolHistory {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBolHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["trackedBolId"] = this.trackedBolId;
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["serviceCategory"] = this.serviceCategory;
        data["comment"] = this.comment;
        data["declarationNumber"] = this.declarationNumber;
        data["estimatedValue"] = this.estimatedValue;
        data["receiptNumber"] = this.receiptNumber;
        data["orderReferenceNumber"] = this.orderReferenceNumber;
        data["paymentAmount"] = this.paymentAmount;
        data["gatePassNumber"] = this.gatePassNumber;
        data["pickUpDate"] = this.pickUpDate;
        data["notificationGenerated"] = this.notificationGenerated;
        data["gatePassResponse"] = this.gatePassResponse;
        data["customsRelease"] = this.customsRelease;
        data["currentStatusForCustomer"] = this.currentStatusForCustomer;
        return data; 
    }

    clone(): TrackedBolHistory {
        const json = this.toJSON();
        let result = new TrackedBolHistory();
        result.init(json);
        return result;
    }
}

export interface ITrackedBolHistory {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    trackedBolId?: string;
    trackedBol?: ITrackedBol;
    status?: TrackedBolStatus;
    serviceCategory?: TrackedBolServiceCategory;
    comment?: string | undefined;
    declarationNumber?: string | undefined;
    estimatedValue?: number | undefined;
    receiptNumber?: string | undefined;
    orderReferenceNumber?: string | undefined;
    paymentAmount?: number | undefined;
    gatePassNumber?: string | undefined;
    pickUpDate?: string | undefined;
    notificationGenerated?: boolean | undefined;
    gatePassResponse?: string | undefined;
    customsRelease?: string | undefined;
    currentStatusForCustomer?: string | undefined;
}

export class TrackedBolFileType implements ITrackedBolFileType {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITrackedBolFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TrackedBolFileType {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBolFileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): TrackedBolFileType {
        const json = this.toJSON();
        let result = new TrackedBolFileType();
        result.init(json);
        return result;
    }
}

export interface ITrackedBolFileType {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class TrackedBolFile implements ITrackedBolFile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    bolFileTypeId?: string;
    bolFileType?: TrackedBolFileType;
    trackedBol?: TrackedBol;
    trackedBolId?: string | undefined;
    fileId?: string | undefined;

    constructor(data?: ITrackedBolFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.bolFileType = data.bolFileType && !(<any>data.bolFileType).toJSON ? new TrackedBolFileType(data.bolFileType) : <TrackedBolFileType>this.bolFileType; 
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.name = _data["name"];
            this.bolFileTypeId = _data["bolFileTypeId"];
            this.bolFileType = _data["bolFileType"] ? TrackedBolFileType.fromJS(_data["bolFileType"]) : <any>undefined;
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
            this.trackedBolId = _data["trackedBolId"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): TrackedBolFile {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBolFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["name"] = this.name;
        data["bolFileTypeId"] = this.bolFileTypeId;
        data["bolFileType"] = this.bolFileType ? this.bolFileType.toJSON() : <any>undefined;
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        data["trackedBolId"] = this.trackedBolId;
        data["fileId"] = this.fileId;
        return data; 
    }

    clone(): TrackedBolFile {
        const json = this.toJSON();
        let result = new TrackedBolFile();
        result.init(json);
        return result;
    }
}

export interface ITrackedBolFile {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    bolFileTypeId?: string;
    bolFileType?: ITrackedBolFileType;
    trackedBol?: ITrackedBol;
    trackedBolId?: string | undefined;
    fileId?: string | undefined;
}

export class TrackedBol implements ITrackedBol {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    bolReferenceNumber?: string | undefined;
    cngReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    mobile?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    shipperName?: string | undefined;
    consigneeName?: string | undefined;
    cargoDescription?: string | undefined;
    numberOfPieces?: string[] | undefined;
    referredEmployeeId?: string | undefined;
    referredEmployee?: Employee;
    serviceCategory?: TrackedBolServiceCategory;
    value?: number | undefined;
    isFlaggedInApm?: boolean;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    tariffCodeDescription?: { [key: string]: string; } | undefined;
    trackedBolHistories?: TrackedBolHistory[] | undefined;
    bolFiles?: TrackedBolFile[] | undefined;
    readonly currentStatusForCustomer?: string | undefined;

    constructor(data?: ITrackedBol) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.referredEmployee = data.referredEmployee && !(<any>data.referredEmployee).toJSON ? new Employee(data.referredEmployee) : <Employee>this.referredEmployee; 
            if (data.trackedBolHistories) {
                this.trackedBolHistories = [];
                for (let i = 0; i < data.trackedBolHistories.length; i++) {
                    let item = data.trackedBolHistories[i];
                    this.trackedBolHistories[i] = item && !(<any>item).toJSON ? new TrackedBolHistory(item) : <TrackedBolHistory>item;
                }
            }
            if (data.bolFiles) {
                this.bolFiles = [];
                for (let i = 0; i < data.bolFiles.length; i++) {
                    let item = data.bolFiles[i];
                    this.bolFiles[i] = item && !(<any>item).toJSON ? new TrackedBolFile(item) : <TrackedBolFile>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.bolReferenceNumber = _data["bolReferenceNumber"];
            this.cngReferenceNumber = _data["cngReferenceNumber"];
            this.bolNumber = _data["bolNumber"];
            this.description = _data["description"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userFullName = _data["userFullName"];
            this.mobile = _data["mobile"];
            this.vessel = _data["vessel"];
            this.voyage = _data["voyage"];
            this.wharehouseLocation = _data["wharehouseLocation"];
            this.shipperName = _data["shipperName"];
            this.consigneeName = _data["consigneeName"];
            this.cargoDescription = _data["cargoDescription"];
            if (Array.isArray(_data["numberOfPieces"])) {
                this.numberOfPieces = [] as any;
                for (let item of _data["numberOfPieces"])
                    this.numberOfPieces!.push(item);
            }
            this.referredEmployeeId = _data["referredEmployeeId"];
            this.referredEmployee = _data["referredEmployee"] ? Employee.fromJS(_data["referredEmployee"]) : <any>undefined;
            this.serviceCategory = _data["serviceCategory"];
            this.value = _data["value"];
            this.isFlaggedInApm = _data["isFlaggedInApm"];
            this.arrivalDate = _data["arrivalDate"];
            this.currentStatus = _data["currentStatus"];
            if (_data["tariffCodeDescription"]) {
                this.tariffCodeDescription = {} as any;
                for (let key in _data["tariffCodeDescription"]) {
                    if (_data["tariffCodeDescription"].hasOwnProperty(key))
                        this.tariffCodeDescription![key] = _data["tariffCodeDescription"][key];
                }
            }
            if (Array.isArray(_data["trackedBolHistories"])) {
                this.trackedBolHistories = [] as any;
                for (let item of _data["trackedBolHistories"])
                    this.trackedBolHistories!.push(TrackedBolHistory.fromJS(item));
            }
            if (Array.isArray(_data["bolFiles"])) {
                this.bolFiles = [] as any;
                for (let item of _data["bolFiles"])
                    this.bolFiles!.push(TrackedBolFile.fromJS(item));
            }
            (<any>this).currentStatusForCustomer = _data["currentStatusForCustomer"];
        }
    }

    static fromJS(data: any): TrackedBol {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBol();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["bolReferenceNumber"] = this.bolReferenceNumber;
        data["cngReferenceNumber"] = this.cngReferenceNumber;
        data["bolNumber"] = this.bolNumber;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userFullName"] = this.userFullName;
        data["mobile"] = this.mobile;
        data["vessel"] = this.vessel;
        data["voyage"] = this.voyage;
        data["wharehouseLocation"] = this.wharehouseLocation;
        data["shipperName"] = this.shipperName;
        data["consigneeName"] = this.consigneeName;
        data["cargoDescription"] = this.cargoDescription;
        if (Array.isArray(this.numberOfPieces)) {
            data["numberOfPieces"] = [];
            for (let item of this.numberOfPieces)
                data["numberOfPieces"].push(item);
        }
        data["referredEmployeeId"] = this.referredEmployeeId;
        data["referredEmployee"] = this.referredEmployee ? this.referredEmployee.toJSON() : <any>undefined;
        data["serviceCategory"] = this.serviceCategory;
        data["value"] = this.value;
        data["isFlaggedInApm"] = this.isFlaggedInApm;
        data["arrivalDate"] = this.arrivalDate;
        data["currentStatus"] = this.currentStatus;
        if (this.tariffCodeDescription) {
            data["tariffCodeDescription"] = {};
            for (let key in this.tariffCodeDescription) {
                if (this.tariffCodeDescription.hasOwnProperty(key))
                    data["tariffCodeDescription"][key] = this.tariffCodeDescription[key];
            }
        }
        if (Array.isArray(this.trackedBolHistories)) {
            data["trackedBolHistories"] = [];
            for (let item of this.trackedBolHistories)
                data["trackedBolHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.bolFiles)) {
            data["bolFiles"] = [];
            for (let item of this.bolFiles)
                data["bolFiles"].push(item.toJSON());
        }
        data["currentStatusForCustomer"] = this.currentStatusForCustomer;
        return data; 
    }

    clone(): TrackedBol {
        const json = this.toJSON();
        let result = new TrackedBol();
        result.init(json);
        return result;
    }
}

export interface ITrackedBol {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    bolReferenceNumber?: string | undefined;
    cngReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    mobile?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    shipperName?: string | undefined;
    consigneeName?: string | undefined;
    cargoDescription?: string | undefined;
    numberOfPieces?: string[] | undefined;
    referredEmployeeId?: string | undefined;
    referredEmployee?: IEmployee;
    serviceCategory?: TrackedBolServiceCategory;
    value?: number | undefined;
    isFlaggedInApm?: boolean;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    tariffCodeDescription?: { [key: string]: string; } | undefined;
    trackedBolHistories?: ITrackedBolHistory[] | undefined;
    bolFiles?: ITrackedBolFile[] | undefined;
    currentStatusForCustomer?: string | undefined;
}

export class GetFilteredTrackedBolForLoggedInUserQueryResponse implements IGetFilteredTrackedBolForLoggedInUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: TrackedBol[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredTrackedBolForLoggedInUserQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new TrackedBol(item) : <TrackedBol>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrackedBol.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolForLoggedInUserQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolForLoggedInUserQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredTrackedBolForLoggedInUserQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolForLoggedInUserQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolForLoggedInUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ITrackedBol[] | undefined;
    count?: number;
}

export class GetFilteredTrackedBolForAdminQueryRequest implements IGetFilteredTrackedBolForAdminQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredTrackedBolForAdminQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolForAdminQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolForAdminQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredTrackedBolForAdminQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolForAdminQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolForAdminQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetFilteredTrackedBolForAdminQueryResponse implements IGetFilteredTrackedBolForAdminQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: TrackedBol[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredTrackedBolForAdminQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new TrackedBol(item) : <TrackedBol>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrackedBol.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolForAdminQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolForAdminQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredTrackedBolForAdminQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolForAdminQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolForAdminQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ITrackedBol[] | undefined;
    count?: number;
}

export class GetTrackedBolDetailsByIdCommandRequest implements IGetTrackedBolDetailsByIdCommandRequest {
    id?: string | undefined;

    constructor(data?: IGetTrackedBolDetailsByIdCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTrackedBolDetailsByIdCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackedBolDetailsByIdCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetTrackedBolDetailsByIdCommandRequest {
        const json = this.toJSON();
        let result = new GetTrackedBolDetailsByIdCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetTrackedBolDetailsByIdCommandRequest {
    id?: string | undefined;
}

export class GetTrackedBolDetailsByIdCommandResponse implements IGetTrackedBolDetailsByIdCommandResponse {
    trackedBol?: TrackedBol;

    constructor(data?: IGetTrackedBolDetailsByIdCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrackedBolDetailsByIdCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackedBolDetailsByIdCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetTrackedBolDetailsByIdCommandResponse {
        const json = this.toJSON();
        let result = new GetTrackedBolDetailsByIdCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTrackedBolDetailsByIdCommandResponse {
    trackedBol?: ITrackedBol;
}

export class UpdateTrackedBolCommandRequest implements IUpdateTrackedBolCommandRequest {
    id?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    serviceCategory?: TrackedBolServiceCategory;

    constructor(data?: IUpdateTrackedBolCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bolReferenceNumber = _data["bolReferenceNumber"];
            this.bolNumber = _data["bolNumber"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userFullName = _data["userFullName"];
            this.vessel = _data["vessel"];
            this.voyage = _data["voyage"];
            this.wharehouseLocation = _data["wharehouseLocation"];
            this.arrivalDate = _data["arrivalDate"];
            this.serviceCategory = _data["serviceCategory"];
        }
    }

    static fromJS(data: any): UpdateTrackedBolCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bolReferenceNumber"] = this.bolReferenceNumber;
        data["bolNumber"] = this.bolNumber;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userFullName"] = this.userFullName;
        data["vessel"] = this.vessel;
        data["voyage"] = this.voyage;
        data["wharehouseLocation"] = this.wharehouseLocation;
        data["arrivalDate"] = this.arrivalDate;
        data["serviceCategory"] = this.serviceCategory;
        return data; 
    }

    clone(): UpdateTrackedBolCommandRequest {
        const json = this.toJSON();
        let result = new UpdateTrackedBolCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolCommandRequest {
    id?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    serviceCategory?: TrackedBolServiceCategory;
}

export class UpdateTrackedBolCommandResponse implements IUpdateTrackedBolCommandResponse {
    trackedBol?: TrackedBol;

    constructor(data?: IUpdateTrackedBolCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTrackedBolCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateTrackedBolCommandResponse {
        const json = this.toJSON();
        let result = new UpdateTrackedBolCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolCommandResponse {
    trackedBol?: ITrackedBol;
}

export class UpdateTrackedBolStatusCommandRequest implements IUpdateTrackedBolStatusCommandRequest {
    trackedBolId?: string;
    newStatus?: TrackedBolStatus;
    comment?: string | undefined;
    declarationNumber?: string | undefined;
    estimatedValue?: number | undefined;
    receiptNumber?: string | undefined;
    orderReferenceNumber?: string | undefined;
    customsRelease?: string | undefined;
    paymentAmount?: number | undefined;
    gatePassNumber?: string | undefined;
    pickUpDate?: string | undefined;

    constructor(data?: IUpdateTrackedBolStatusCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBolId = _data["trackedBolId"];
            this.newStatus = _data["newStatus"];
            this.comment = _data["comment"];
            this.declarationNumber = _data["declarationNumber"];
            this.estimatedValue = _data["estimatedValue"];
            this.receiptNumber = _data["receiptNumber"];
            this.orderReferenceNumber = _data["orderReferenceNumber"];
            this.customsRelease = _data["customsRelease"];
            this.paymentAmount = _data["paymentAmount"];
            this.gatePassNumber = _data["gatePassNumber"];
            this.pickUpDate = _data["pickUpDate"];
        }
    }

    static fromJS(data: any): UpdateTrackedBolStatusCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolStatusCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBolId"] = this.trackedBolId;
        data["newStatus"] = this.newStatus;
        data["comment"] = this.comment;
        data["declarationNumber"] = this.declarationNumber;
        data["estimatedValue"] = this.estimatedValue;
        data["receiptNumber"] = this.receiptNumber;
        data["orderReferenceNumber"] = this.orderReferenceNumber;
        data["customsRelease"] = this.customsRelease;
        data["paymentAmount"] = this.paymentAmount;
        data["gatePassNumber"] = this.gatePassNumber;
        data["pickUpDate"] = this.pickUpDate;
        return data; 
    }

    clone(): UpdateTrackedBolStatusCommandRequest {
        const json = this.toJSON();
        let result = new UpdateTrackedBolStatusCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolStatusCommandRequest {
    trackedBolId?: string;
    newStatus?: TrackedBolStatus;
    comment?: string | undefined;
    declarationNumber?: string | undefined;
    estimatedValue?: number | undefined;
    receiptNumber?: string | undefined;
    orderReferenceNumber?: string | undefined;
    customsRelease?: string | undefined;
    paymentAmount?: number | undefined;
    gatePassNumber?: string | undefined;
    pickUpDate?: string | undefined;
}

export class UpdateTrackedBolStatusCommandResponse implements IUpdateTrackedBolStatusCommandResponse {
    trackedBol?: TrackedBol;

    constructor(data?: IUpdateTrackedBolStatusCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTrackedBolStatusCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolStatusCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateTrackedBolStatusCommandResponse {
        const json = this.toJSON();
        let result = new UpdateTrackedBolStatusCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolStatusCommandResponse {
    trackedBol?: ITrackedBol;
}

export class TrackedBolFileModel implements ITrackedBolFileModel {
    id?: string;
    fileId?: string | undefined;
    name?: string | undefined;
    bolFileTypeId?: string;
    data?: string | undefined;

    constructor(data?: ITrackedBolFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.bolFileTypeId = _data["bolFileTypeId"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): TrackedBolFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBolFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["bolFileTypeId"] = this.bolFileTypeId;
        data["data"] = this.data;
        return data; 
    }

    clone(): TrackedBolFileModel {
        const json = this.toJSON();
        let result = new TrackedBolFileModel();
        result.init(json);
        return result;
    }
}

export interface ITrackedBolFileModel {
    id?: string;
    fileId?: string | undefined;
    name?: string | undefined;
    bolFileTypeId?: string;
    data?: string | undefined;
}

export class AddTrackedBolRequestModel implements IAddTrackedBolRequestModel {
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    mobile?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    tariffCodeDescriptionIds?: string[] | undefined;
    value?: number | undefined;
    bolFiles?: TrackedBolFileModel[] | undefined;
    shipperName?: string | undefined;
    cargoDescription?: string | undefined;
    consigneeName?: string | undefined;
    serviceCategory?: TrackedBolServiceCategory;
    numberOfPieces?: string[] | undefined;

    constructor(data?: IAddTrackedBolRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bolFiles) {
                this.bolFiles = [];
                for (let i = 0; i < data.bolFiles.length; i++) {
                    let item = data.bolFiles[i];
                    this.bolFiles[i] = item && !(<any>item).toJSON ? new TrackedBolFileModel(item) : <TrackedBolFileModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bolReferenceNumber = _data["bolReferenceNumber"];
            this.bolNumber = _data["bolNumber"];
            this.description = _data["description"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userFullName = _data["userFullName"];
            this.mobile = _data["mobile"];
            this.vessel = _data["vessel"];
            this.voyage = _data["voyage"];
            this.wharehouseLocation = _data["wharehouseLocation"];
            this.arrivalDate = _data["arrivalDate"];
            this.currentStatus = _data["currentStatus"];
            if (Array.isArray(_data["tariffCodeDescriptionIds"])) {
                this.tariffCodeDescriptionIds = [] as any;
                for (let item of _data["tariffCodeDescriptionIds"])
                    this.tariffCodeDescriptionIds!.push(item);
            }
            this.value = _data["value"];
            if (Array.isArray(_data["bolFiles"])) {
                this.bolFiles = [] as any;
                for (let item of _data["bolFiles"])
                    this.bolFiles!.push(TrackedBolFileModel.fromJS(item));
            }
            this.shipperName = _data["shipperName"];
            this.cargoDescription = _data["cargoDescription"];
            this.consigneeName = _data["consigneeName"];
            this.serviceCategory = _data["serviceCategory"];
            if (Array.isArray(_data["numberOfPieces"])) {
                this.numberOfPieces = [] as any;
                for (let item of _data["numberOfPieces"])
                    this.numberOfPieces!.push(item);
            }
        }
    }

    static fromJS(data: any): AddTrackedBolRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrackedBolRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bolReferenceNumber"] = this.bolReferenceNumber;
        data["bolNumber"] = this.bolNumber;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userFullName"] = this.userFullName;
        data["mobile"] = this.mobile;
        data["vessel"] = this.vessel;
        data["voyage"] = this.voyage;
        data["wharehouseLocation"] = this.wharehouseLocation;
        data["arrivalDate"] = this.arrivalDate;
        data["currentStatus"] = this.currentStatus;
        if (Array.isArray(this.tariffCodeDescriptionIds)) {
            data["tariffCodeDescriptionIds"] = [];
            for (let item of this.tariffCodeDescriptionIds)
                data["tariffCodeDescriptionIds"].push(item);
        }
        data["value"] = this.value;
        if (Array.isArray(this.bolFiles)) {
            data["bolFiles"] = [];
            for (let item of this.bolFiles)
                data["bolFiles"].push(item.toJSON());
        }
        data["shipperName"] = this.shipperName;
        data["cargoDescription"] = this.cargoDescription;
        data["consigneeName"] = this.consigneeName;
        data["serviceCategory"] = this.serviceCategory;
        if (Array.isArray(this.numberOfPieces)) {
            data["numberOfPieces"] = [];
            for (let item of this.numberOfPieces)
                data["numberOfPieces"].push(item);
        }
        return data; 
    }

    clone(): AddTrackedBolRequestModel {
        const json = this.toJSON();
        let result = new AddTrackedBolRequestModel();
        result.init(json);
        return result;
    }
}

export interface IAddTrackedBolRequestModel {
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userFullName?: string | undefined;
    mobile?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    tariffCodeDescriptionIds?: string[] | undefined;
    value?: number | undefined;
    bolFiles?: ITrackedBolFileModel[] | undefined;
    shipperName?: string | undefined;
    cargoDescription?: string | undefined;
    consigneeName?: string | undefined;
    serviceCategory?: TrackedBolServiceCategory;
    numberOfPieces?: string[] | undefined;
}

export class AddTrackedBolCommandRequest implements IAddTrackedBolCommandRequest {
    addTrackedBolRequests?: AddTrackedBolRequestModel[] | undefined;

    constructor(data?: IAddTrackedBolCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.addTrackedBolRequests) {
                this.addTrackedBolRequests = [];
                for (let i = 0; i < data.addTrackedBolRequests.length; i++) {
                    let item = data.addTrackedBolRequests[i];
                    this.addTrackedBolRequests[i] = item && !(<any>item).toJSON ? new AddTrackedBolRequestModel(item) : <AddTrackedBolRequestModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addTrackedBolRequests"])) {
                this.addTrackedBolRequests = [] as any;
                for (let item of _data["addTrackedBolRequests"])
                    this.addTrackedBolRequests!.push(AddTrackedBolRequestModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddTrackedBolCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrackedBolCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addTrackedBolRequests)) {
            data["addTrackedBolRequests"] = [];
            for (let item of this.addTrackedBolRequests)
                data["addTrackedBolRequests"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AddTrackedBolCommandRequest {
        const json = this.toJSON();
        let result = new AddTrackedBolCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IAddTrackedBolCommandRequest {
    addTrackedBolRequests?: IAddTrackedBolRequestModel[] | undefined;
}

export class AddTrackedBolResponseModel implements IAddTrackedBolResponseModel {
    cnGRef?: string | undefined;
    bolNumber?: string | undefined;
    successful?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IAddTrackedBolResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cnGRef = _data["cnGRef"];
            this.bolNumber = _data["bolNumber"];
            this.successful = _data["successful"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AddTrackedBolResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrackedBolResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cnGRef"] = this.cnGRef;
        data["bolNumber"] = this.bolNumber;
        data["successful"] = this.successful;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }

    clone(): AddTrackedBolResponseModel {
        const json = this.toJSON();
        let result = new AddTrackedBolResponseModel();
        result.init(json);
        return result;
    }
}

export interface IAddTrackedBolResponseModel {
    cnGRef?: string | undefined;
    bolNumber?: string | undefined;
    successful?: boolean;
    errorMessage?: string | undefined;
}

export class AddTrackedBolCommandResponse implements IAddTrackedBolCommandResponse {
    trackedBols?: AddTrackedBolResponseModel[] | undefined;
    failedToAddAll?: boolean;

    constructor(data?: IAddTrackedBolCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.trackedBols) {
                this.trackedBols = [];
                for (let i = 0; i < data.trackedBols.length; i++) {
                    let item = data.trackedBols[i];
                    this.trackedBols[i] = item && !(<any>item).toJSON ? new AddTrackedBolResponseModel(item) : <AddTrackedBolResponseModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trackedBols"])) {
                this.trackedBols = [] as any;
                for (let item of _data["trackedBols"])
                    this.trackedBols!.push(AddTrackedBolResponseModel.fromJS(item));
            }
            this.failedToAddAll = _data["failedToAddAll"];
        }
    }

    static fromJS(data: any): AddTrackedBolCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrackedBolCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackedBols)) {
            data["trackedBols"] = [];
            for (let item of this.trackedBols)
                data["trackedBols"].push(item.toJSON());
        }
        data["failedToAddAll"] = this.failedToAddAll;
        return data; 
    }

    clone(): AddTrackedBolCommandResponse {
        const json = this.toJSON();
        let result = new AddTrackedBolCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddTrackedBolCommandResponse {
    trackedBols?: IAddTrackedBolResponseModel[] | undefined;
    failedToAddAll?: boolean;
}

export class GetTrackedBolDetailsByBolReferenceCommandRequest implements IGetTrackedBolDetailsByBolReferenceCommandRequest {
    bolReference?: string | undefined;

    constructor(data?: IGetTrackedBolDetailsByBolReferenceCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bolReference = _data["bolReference"];
        }
    }

    static fromJS(data: any): GetTrackedBolDetailsByBolReferenceCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackedBolDetailsByBolReferenceCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bolReference"] = this.bolReference;
        return data; 
    }

    clone(): GetTrackedBolDetailsByBolReferenceCommandRequest {
        const json = this.toJSON();
        let result = new GetTrackedBolDetailsByBolReferenceCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetTrackedBolDetailsByBolReferenceCommandRequest {
    bolReference?: string | undefined;
}

export class SlimTrackedBol implements ISlimTrackedBol {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    readonly currentStatusForCustomer?: string | undefined;

    constructor(data?: ISlimTrackedBol) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.bolReferenceNumber = _data["bolReferenceNumber"];
            this.bolNumber = _data["bolNumber"];
            this.vessel = _data["vessel"];
            this.voyage = _data["voyage"];
            this.wharehouseLocation = _data["wharehouseLocation"];
            this.arrivalDate = _data["arrivalDate"];
            this.currentStatus = _data["currentStatus"];
            (<any>this).currentStatusForCustomer = _data["currentStatusForCustomer"];
        }
    }

    static fromJS(data: any): SlimTrackedBol {
        data = typeof data === 'object' ? data : {};
        let result = new SlimTrackedBol();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["bolReferenceNumber"] = this.bolReferenceNumber;
        data["bolNumber"] = this.bolNumber;
        data["vessel"] = this.vessel;
        data["voyage"] = this.voyage;
        data["wharehouseLocation"] = this.wharehouseLocation;
        data["arrivalDate"] = this.arrivalDate;
        data["currentStatus"] = this.currentStatus;
        data["currentStatusForCustomer"] = this.currentStatusForCustomer;
        return data; 
    }

    clone(): SlimTrackedBol {
        const json = this.toJSON();
        let result = new SlimTrackedBol();
        result.init(json);
        return result;
    }
}

export interface ISlimTrackedBol {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    wharehouseLocation?: string | undefined;
    arrivalDate?: string | undefined;
    currentStatus?: TrackedBolStatus;
    currentStatusForCustomer?: string | undefined;
}

export class GetTrackedBolDetailsByBolReferenceCommandResponse implements IGetTrackedBolDetailsByBolReferenceCommandResponse {
    trackedBol?: SlimTrackedBol;

    constructor(data?: IGetTrackedBolDetailsByBolReferenceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new SlimTrackedBol(data.trackedBol) : <SlimTrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBol = _data["trackedBol"] ? SlimTrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrackedBolDetailsByBolReferenceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackedBolDetailsByBolReferenceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetTrackedBolDetailsByBolReferenceCommandResponse {
        const json = this.toJSON();
        let result = new GetTrackedBolDetailsByBolReferenceCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTrackedBolDetailsByBolReferenceCommandResponse {
    trackedBol?: ISlimTrackedBol;
}

export class GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest implements IGetFilteredTrackedBolDescriptionForLoggedUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredTrackedBolDescriptionForLoggedUserQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolDescriptionForLoggedUserQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolDescriptionForLoggedUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class TrackedBolDescription implements ITrackedBolDescription {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITrackedBolDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TrackedBolDescription {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedBolDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }

    clone(): TrackedBolDescription {
        const json = this.toJSON();
        let result = new TrackedBolDescription();
        result.init(json);
        return result;
    }
}

export interface ITrackedBolDescription {
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse implements IGetFilteredTrackedBolDescriptionForLoggedUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: TrackedBolDescription[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredTrackedBolDescriptionForLoggedUserQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new TrackedBolDescription(item) : <TrackedBolDescription>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrackedBolDescription.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolDescriptionForLoggedUserQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolDescriptionForLoggedUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ITrackedBolDescription[] | undefined;
    count?: number;
}

export class UpdateTrackedBolSupplementaryInfoRequestModel implements IUpdateTrackedBolSupplementaryInfoRequestModel {
    id?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    userId?: string | undefined;
    tariffCodeDescriptionIds?: string[] | undefined;
    value?: number | undefined;
    bolFiles?: TrackedBolFileModel[] | undefined;
    serviceCategory?: TrackedBolServiceCategory;

    constructor(data?: IUpdateTrackedBolSupplementaryInfoRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bolFiles) {
                this.bolFiles = [];
                for (let i = 0; i < data.bolFiles.length; i++) {
                    let item = data.bolFiles[i];
                    this.bolFiles[i] = item && !(<any>item).toJSON ? new TrackedBolFileModel(item) : <TrackedBolFileModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bolReferenceNumber = _data["bolReferenceNumber"];
            this.bolNumber = _data["bolNumber"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["tariffCodeDescriptionIds"])) {
                this.tariffCodeDescriptionIds = [] as any;
                for (let item of _data["tariffCodeDescriptionIds"])
                    this.tariffCodeDescriptionIds!.push(item);
            }
            this.value = _data["value"];
            if (Array.isArray(_data["bolFiles"])) {
                this.bolFiles = [] as any;
                for (let item of _data["bolFiles"])
                    this.bolFiles!.push(TrackedBolFileModel.fromJS(item));
            }
            this.serviceCategory = _data["serviceCategory"];
        }
    }

    static fromJS(data: any): UpdateTrackedBolSupplementaryInfoRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolSupplementaryInfoRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bolReferenceNumber"] = this.bolReferenceNumber;
        data["bolNumber"] = this.bolNumber;
        data["userId"] = this.userId;
        if (Array.isArray(this.tariffCodeDescriptionIds)) {
            data["tariffCodeDescriptionIds"] = [];
            for (let item of this.tariffCodeDescriptionIds)
                data["tariffCodeDescriptionIds"].push(item);
        }
        data["value"] = this.value;
        if (Array.isArray(this.bolFiles)) {
            data["bolFiles"] = [];
            for (let item of this.bolFiles)
                data["bolFiles"].push(item.toJSON());
        }
        data["serviceCategory"] = this.serviceCategory;
        return data; 
    }

    clone(): UpdateTrackedBolSupplementaryInfoRequestModel {
        const json = this.toJSON();
        let result = new UpdateTrackedBolSupplementaryInfoRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolSupplementaryInfoRequestModel {
    id?: string | undefined;
    bolReferenceNumber?: string | undefined;
    bolNumber?: string | undefined;
    userId?: string | undefined;
    tariffCodeDescriptionIds?: string[] | undefined;
    value?: number | undefined;
    bolFiles?: ITrackedBolFileModel[] | undefined;
    serviceCategory?: TrackedBolServiceCategory;
}

export class UpdateTrackedBolSupplementaryInfoRequest implements IUpdateTrackedBolSupplementaryInfoRequest {
    trackedBolSupplementaryInfo?: UpdateTrackedBolSupplementaryInfoRequestModel;

    constructor(data?: IUpdateTrackedBolSupplementaryInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBolSupplementaryInfo = data.trackedBolSupplementaryInfo && !(<any>data.trackedBolSupplementaryInfo).toJSON ? new UpdateTrackedBolSupplementaryInfoRequestModel(data.trackedBolSupplementaryInfo) : <UpdateTrackedBolSupplementaryInfoRequestModel>this.trackedBolSupplementaryInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBolSupplementaryInfo = _data["trackedBolSupplementaryInfo"] ? UpdateTrackedBolSupplementaryInfoRequestModel.fromJS(_data["trackedBolSupplementaryInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTrackedBolSupplementaryInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolSupplementaryInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBolSupplementaryInfo"] = this.trackedBolSupplementaryInfo ? this.trackedBolSupplementaryInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateTrackedBolSupplementaryInfoRequest {
        const json = this.toJSON();
        let result = new UpdateTrackedBolSupplementaryInfoRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolSupplementaryInfoRequest {
    trackedBolSupplementaryInfo?: IUpdateTrackedBolSupplementaryInfoRequestModel;
}

export class UpdateTrackedBolSupplementaryInfoResponse implements IUpdateTrackedBolSupplementaryInfoResponse {
    trackedBol?: TrackedBol;

    constructor(data?: IUpdateTrackedBolSupplementaryInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.trackedBol = data.trackedBol && !(<any>data.trackedBol).toJSON ? new TrackedBol(data.trackedBol) : <TrackedBol>this.trackedBol; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedBol = _data["trackedBol"] ? TrackedBol.fromJS(_data["trackedBol"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTrackedBolSupplementaryInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedBolSupplementaryInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedBol"] = this.trackedBol ? this.trackedBol.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UpdateTrackedBolSupplementaryInfoResponse {
        const json = this.toJSON();
        let result = new UpdateTrackedBolSupplementaryInfoResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrackedBolSupplementaryInfoResponse {
    trackedBol?: ITrackedBol;
}

export class GetCustomerTrackedBolReportRequest implements IGetCustomerTrackedBolReportRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetCustomerTrackedBolReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomerTrackedBolReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerTrackedBolReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCustomerTrackedBolReportRequest {
        const json = this.toJSON();
        let result = new GetCustomerTrackedBolReportRequest();
        result.init(json);
        return result;
    }
}

export interface IGetCustomerTrackedBolReportRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest implements IGetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse implements IGetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;
    results?: TrackedBolFileType[] | undefined;
    count?: number;

    constructor(data?: IGetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new TrackedBolFileType(item) : <TrackedBolFileType>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrackedBolFileType.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data; 
    }

    clone(): GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse {
        const json = this.toJSON();
        let result = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFilteredTrackedBolFileTypeForLoggedInUserQueryResponse {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
    results?: ITrackedBolFileType[] | undefined;
    count?: number;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canTimeout?: boolean;
    readonly canWrite?: boolean;
    readonly length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    canWrite?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class GetTrackedBolFileByIdQueryResponse implements IGetTrackedBolFileByIdQueryResponse {
    file?: Stream;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;

    constructor(data?: IGetTrackedBolFileByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new Stream(data.file) : <Stream>this.file; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? Stream.fromJS(_data["file"]) : <any>undefined;
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): GetTrackedBolFileByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackedBolFileByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        return data; 
    }

    clone(): GetTrackedBolFileByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetTrackedBolFileByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTrackedBolFileByIdQueryResponse {
    file?: IStream;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
}

export enum Operations {
    Create_Meal_Plan = "Create Meal Plan",
    Is_Autenticated = "Is Autenticated",
    View_Tracked_Bol = "View Tracked Bol",
    Edit_Tracked_Bol = "Edit Tracked Bol",
    Move_Traced_Bol_Status_Back = "Move Traced Bol Status Back",
    Has_Customer_Code = "Has Customer Code",
    Create_Employee = "Create Employee",
    View_Employee = "View Employee",
    Edit_Employee = "Edit Employee",
    Delete_Employee = "Delete Employee",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}